/**
 * EDI申込み管理
 */
import Vue from 'vue'
import * as httpConst from '../../../constants/httpConst'
import * as types from '../../mutation-types/admin-types'

const API_PATH = `${httpConst.ADMIN_ENDPOINT}/edi_requests`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0,
      total_pages: 1
    },
    condition: {
      tenant_code: null,
      tenant_name: null,
      emission_name: null,
      status_tab: 0,
      request_type: null,
      emission_ids: []
    },
  }
}

const ediRequest = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: (state) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    index ({ dispatch, commit, state }, { tenant_code, tenant_name, emission_name, status_tab, request_type,page, emission_ids, limit, format }) {
      const api_path = format === 'csv' ? `${API_PATH}.csv` : `${API_PATH}`
      dispatch('saveCondition', { tenant_code, tenant_name, emission_name, status_tab, request_type, emission_ids })
      const params = {
        tenant_code: state.condition.tenant_code,
        tenant_name: state.condition.tenant_name,
        emission_name: state.condition.emission_name,
        status_tab: state.condition.status_tab,
        request_type: state.condition.request_type,
        emission_ids: state.condition.emission_ids,
        limit: limit,
        page: page
      }
      return new Promise((resolve, reject) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          if (format != 'csv') {
            let content = data.content
            commit(types.ADMIN_EDI_REQUEST, { content })
            resolve(content)
          } else {
            resolve(data)
          }
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve, reject) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        }).catch(error => {
          reject(error)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        Vue.$http.post(API_PATH, params).then(data => {
          commit
          resolve(data.content)
        }).catch(error => {
          reject(error)
        })
      })
    },
    saveCondition ({ commit, state }, { tenant_code, tenant_name, emission_name, status_tab, request_type, emission_ids }) {
      const _tenant_code = (tenant_code !== undefined) ? tenant_code : state.condition.tenant_code
      const _tenant_name = (tenant_name !== undefined) ? tenant_name : state.condition.tenant_name
      const _emission_name = (emission_name !== undefined) ? emission_name : state.condition.emission_name
      const _status_tab = (status_tab !== undefined) ? status_tab : state.condition.status_tab
      const _request_type = (request_type !== undefined) ? request_type : state.condition.request_type
      const _emission_ids = (emission_ids !== undefined) ? emission_ids : []
      const params = {
        tenant_code: _tenant_code,
        tenant_name: _tenant_name,
        emission_name: _emission_name,
        status_tab: _status_tab,
        request_type: _request_type,
        emission_ids: _emission_ids
      }
      commit(types.ADMIN_EDI_REQUEST_CONDITION, { params })
    },
    resetState ({ commit }) {
      commit(types.ADMIN_EDI_REQUEST_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.ADMIN_EDI_REQUEST_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.ADMIN_EDI_REQUEST_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.ADMIN_EDI_REQUEST_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.ADMIN_EDI_REQUEST] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.ADMIN_EDI_REQUEST_CONDITION] (state, { params }) {
      state.condition.tenant_code = params.tenant_code
      state.condition.tenant_name = params.tenant_name
      state.condition.emission_name = params.emission_name
      state.condition.status_tab = params.status_tab
      state.condition.request_type = params.request_type
      state.condition.emission_ids = params.emission_ids
    }
  },
}

export default ediRequest
